import { Text, View } from "@react-pdf/renderer";

import { FillmData } from "~/providers/utils/types/patientIntakePreviewTypes";
import { styles } from "../styles";

export const ConsultationExportSummaryFillm = ({
  fillm,
}: {
  fillm: FillmData;
}) => {
  return (
    <View style={{ flexDirection: "column", rowGap: 8 }}>
      <Text style={{ fontStyle: "italic", fontSize: 10 }}>
        Fillm allows patients, at their discretion, to share summaries and
        reflections related to their personal AI chat history, bringing valuable
        patient information into clinical focus.
      </Text>
      <Text>{fillm.intro_sentence}</Text>
      <Text style={[styles.h3, { marginBottom: 0 }]}>Novel signals</Text>
      <View>
        {fillm.novel.bullets.map((bullet, i) => (
          <View
            key={`novel-${i}`}
            style={{
              flexDirection: "row",
              marginBottom: 4,
              paddingRight: 8,
              fontWeight: 400,
            }}
          >
            <Text style={{ marginRight: 4 }}>•</Text>
            <Text>{bullet}</Text>
          </View>
        ))}
      </View>
      <Text style={[styles.h3, { marginBottom: 0 }]}>Conflicting signals</Text>
      <View>
        {fillm.conflicting.bullets.map((bullet, i) => (
          <View
            key={`conflicting-${i}`}
            style={{
              flexDirection: "row",
              marginBottom: 4,
              paddingRight: 8,
              fontWeight: 400,
            }}
          >
            <Text style={{ marginRight: 4 }}>•</Text>
            <Text>{bullet}</Text>
          </View>
        ))}
      </View>
      <Text style={[styles.h3, { marginBottom: 0 }]}>Congruent signals</Text>
      <View>
        {fillm.congruent.bullets.map((bullet, i) => (
          <View
            key={`congruent-${i}`}
            style={{
              flexDirection: "row",
              marginBottom: 4,
              paddingRight: 8,
              fontWeight: 400,
            }}
          >
            <Text style={{ marginRight: 4 }}>•</Text>
            <Text>{bullet}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};
